import { createQueryPreloader } from '@apollo/client/react';
import { createApolloClient } from 'platform/apolloClient';
import {
  getImpersonatedCustomer,
  subscribeToImpersonatedCustomer,
  useImpersonatedCustomer,
} from 'platform/readOnlyMutations';
import { createZeusApolloClient } from 'platform/zeusClient';

const athenaClient = createApolloClient({ batch: true });
type ZeusClientState = {
  client: ReturnType<typeof createZeusApolloClient>;
  impersonatedCustomerUUID: string | null;
};
let zeusClientState: ZeusClientState | undefined;

subscribeToImpersonatedCustomer((impersonatedCustomerUUID) => {
  if (zeusClientState?.impersonatedCustomerUUID !== impersonatedCustomerUUID) {
    zeusClientState?.client.stop();
    zeusClientState = undefined;
  }
});

export const preloadQuery = createQueryPreloader(athenaClient);
export const apolloClient = () => athenaClient;
const getZeusApolloClient = (
  impersonatedCustomerUUID: string | null,
): ReturnType<typeof createZeusApolloClient> => {
  if (zeusClientState?.impersonatedCustomerUUID === impersonatedCustomerUUID) {
    return zeusClientState.client;
  }

  zeusClientState = {
    client: createZeusApolloClient(impersonatedCustomerUUID ? { impersonatedCustomerUUID } : {}),
    impersonatedCustomerUUID,
  };
  return zeusClientState.client;
};

export const zeusApolloClient = (): ReturnType<typeof createZeusApolloClient> =>
  getZeusApolloClient(getImpersonatedCustomer());

export const useZeusApolloClient = (): ReturnType<typeof createZeusApolloClient> => {
  const impersonatedCustomerUUID = useImpersonatedCustomer();
  return getZeusApolloClient(impersonatedCustomerUUID);
};

export const clearGraphQLStores = async (): Promise<void> => {
  await Promise.all([
    athenaClient.clearStore(),
    ...(zeusClientState ? [zeusClientState.client.clearStore()] : []),
  ]);
};
